var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferralQualifiedIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "User-Check-Validate--Streamline-Core.svg",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "User Check Validate Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-check-validate--actions-close-checkmark-check-geometric-human-person-single-success-up-user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#9f9f9f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5 5.5c1.38071 0 2.5 -1.11929 2.5 -2.5S6.38071 0.5 5 0.5 2.5 1.61929 2.5 3 3.61929 5.5 5 5.5Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#9f9f9f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5 12.5H0.5l0 -0.5421c0.007961 -0.7622 0.208977 -1.51 0.58427 -2.17343 0.3753 -0.66346 0.91263 -1.22097 1.5618 -1.62046 0.64918 -0.3995 1.38902 -0.62793 2.15041 -0.66398 0.06788 -0.00321 0.13574 -0.00489 0.20352 -0.00503 0.06778 0.00014 0.13565 0.00182 0.20353 0.00503 0.76139 0.03605 1.50123 0.26448 2.15041 0.66398 0.3733 0.22972 0.70961 0.51169 0.9994 0.83602",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    stroke: "#9f9f9f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m13.5 8.5 -4 5 -2 -1.5",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralQualifiedIconGrey);
export default __webpack_public_path__ + "static/media/referral-qualified-icon-grey.86a90c69b79fd07e0eb6117cf544fff7.svg";
export { ForwardRef as ReactComponent };